export default __webpack_public_path__ + "1fa93cf086603daf570e26b309ea514d.png";